module.exports = "//static.hsappstatic.net/audio-components/static-1.3147/assets/voice-samples/echo.mp3"